import { envTypes, env } from '@/api/environment';
import { getCountry, getWithDotComByCountry } from '@/utils';

const country = getCountry();
const withCom = getWithDotComByCountry(country);

const apiHostUrls = new Map([
  [envTypes.local, 'http://localhost:5500'],
  [envTypes.dev, 'http://dv.neocom.bsb/controlpanel_api'],
  [envTypes.hom, `http://cp-api.qa.neogig${withCom}${country}`],
  [envTypes.prod, `https://cp-api.neogig${withCom}${country}`],
  [envTypes.refactory, `http://cp-api.refactory.neogig${withCom}${country}`],
  [envTypes.internal, `http://cp-api.internal.neocom`],
]);

const neopvcHostUrls = new Map([
    [envTypes.local, 'http://localhost:5000'],
    [envTypes.dev, 'http://pvc.internal.neocom'],
    [envTypes.hom, 'http://pvc.internal.neocom'],
    [envTypes.prod, 'http://pvc.internal.neocom'],
    [envTypes.internal, `http://pvc.internal.neocom`],
]);

const apiIdentityServerHostUrls = new Map([
  [envTypes.local, `http://identity-server.qa.neogig${withCom}${country}`],
  [envTypes.dev, 'http://dv.neocom.bsb/identity_server'],
  [envTypes.hom, `http://identity-server.qa.neogig${withCom}${country}`],
  [envTypes.prod, `https://identity-server.neogig${withCom}${country}`],
  [envTypes.refactory, `http://identity-server.refactory.neogig${withCom}${country}`],
  [envTypes.internal, `http://identity-server.internal.neocom`],
]);

const redirectHosts = new Map([
  [envTypes.local, 'http://localhost:3000/callback.html'],
  [envTypes.dev, 'http://dv.cp.neocom.bsb/callback.html'],
  [envTypes.hom, `http://cp.qa.neogig${withCom}${country}/callback.html`],
  [envTypes.prod, `https://cp.neogig${withCom}${country}/callback.html`],
  [envTypes.refactory, `http://cp.refactory.neogig${withCom}${country}/callback.html`],
  [envTypes.internal, `http://cp.internal.neocom/callback.html`],
]);

const postLogoutRedirectHosts = new Map([
  [envTypes.local, 'http://localhost:3000'],
  [envTypes.dev, 'http://dv.cp.neocom.bsb'],
  [envTypes.hom, `http://cp.qa.neogig${withCom}${country}`],
  [envTypes.prod, `https://cp.neogig${withCom}${country}`],
  [envTypes.refactory, `http://cp.refactory.neogig${withCom}${country}`],
  [envTypes.internal, `http://cp.internal.neocom`],
]);

const clients = new Map([
  [envTypes.local, 'controlpanel_local'],
  [envTypes.dev, 'controlpanel_dev'],
  [envTypes.hom, 'controlpanel_qa'],
  [envTypes.prod, 'controlpanel'],
  [envTypes.refactory, 'controlpanel_qa'],
  [envTypes.internal, 'controlpanel'],
]);

export const apihost = apiHostUrls.get(env) || '';
export const neopvcHost = neopvcHostUrls.get(env) || '';
export const apiIdentityServerHost = apiIdentityServerHostUrls.get(env) || '';
export const redirectUri = redirectHosts.get(env) || '';
export const postLogoutRedirectUri = postLogoutRedirectHosts.get(env) || '';
export const clientId = clients.get(env) || '';
